import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import LogoTitle from '../../assets/images/logo-s.png'
import './Home.scss'
import AnimatedLettrs from '../AnimatedLetters/AnimatedLettrs'
import Logo from '../Logo/Logo'
import Loader from 'react-loaders'

type Props = {}

const Home = (props: Props) => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const nameArray = 'Volodymyr'.split('')
  const lastNameArray = 'okolenko'.split('')
  const jobArray = 'web developer.'.split('')
  // const nameArray  =["V","o", "l", "o", "d", "y", "m", "y", "r"]
  // const jobArray = ["w", "e", "b", " ", "d", "e", "v", "e", "l", "o", "p", "e", "r", "."]
  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4600)
  }, [])
  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>{' '}
            <AnimatedLettrs
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <img src={LogoTitle} alt="LogoTitle" />
            <AnimatedLettrs
              letterClass={letterClass}
              strArray={lastNameArray}
              idx={24}
            />
            <br />
            <AnimatedLettrs
              letterClass={letterClass}
              strArray={jobArray}
              idx={32}
            />
          </h1>
          <h2>Frontend developer / JavaScript specialist</h2>
          <div className="home-btn-container flex">
            <Link to="/contact" className="flat-button">
              Contact me
            </Link>
            <a
              href="https://drive.google.com/file/d/119oNByoMEkfjyZxIKDlknXlNIqTh6Bji/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
              className="flat-button"
            >
              Resume
            </a>
          </div>
        </div>
        <Logo />
      </div>
      <Loader type="pacman" active />
    </>
  )
}

export default Home
